import { getItemType } from "../getItemType/index.js";

type OrderItem = {
  quantity: number;
  containerType: string | null; // e.g. eKeg, kegStart, bottle, snack, bottle
};

export const getItemTypeQuantities = ({
  orderItemList,
}: {
  orderItemList: OrderItem[];
}) => {
  const quantities = {
    keg: 0,
    can: 0,
    cask: 0,
    bottle: 0,
    draught: 0,
    snack: 0,
    glassware: 0,
    bagInBox: 0,
    jerryCan: 0,
    box: 0,
    any: 0,
  };

  for (const orderItem of orderItemList) {
    const orderItemType = getItemType(orderItem.containerType);

    if (!orderItemType) {
      continue;
    }

    quantities.any = quantities.any + orderItem.quantity;

    if (["keg", "cask"].includes(orderItemType)) {
      quantities.draught = quantities.draught + orderItem.quantity;
    }

    quantities[orderItemType] = quantities[orderItemType] + orderItem.quantity;
  }

  return quantities;
};
